/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var ko = require("knockout");

var pliObservable = require("../forms-knockoutcontrols");
var stringUtil = require("../util/string");

require("../forms-knockoutcontrols-multiselect");

var shared = require("./shared");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// PicklistAdvancedSearchItem template
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

var splitPicklistRegex = new RegExp("([^\\\\\\][^;]|\\\\;)+", "g");

//-------------------------------------------
function PicklistAdvancedSearchItem(behaviourData) {
    if (!(this instanceof PicklistAdvancedSearchItem)) { return new PicklistAdvancedSearchItem(behaviourData); } // if new was not used, force it now

    // indicates how the string fields are searched
    // - `is` include any items with exact matches (default)
    // - `contains` includes any items with partial matches
    // - `is not` excludes any items with exact matches
    // - `is empty` includes items that do not have a value (`enableEmpty` must be set on behaviourData)
    // - `is not empty` includes items that have any value (`enableEmpty` must be set on behaviourData)
    this.operator = ko.observable("is");

    this.value = pliObservable(); // contains value of the phrase to match
    this.selected = pliObservable(null, behaviourData, "multiselect"); // contains the value if picklist

    // extras
    this.extras = function picklistAdvancedSearchItemExtras() { return; };
    this.extras.enableEmpty = !!(behaviourData && behaviourData.enableEmpty);
    this.extras.isEmpty = ko.pureComputed(shared.containsEmpty, this.operator);
}


//-------------------------------------------
PicklistAdvancedSearchItem.prototype.templateId = "picklistAdvancedSearchItem";


//-------------------------------------------
// Loads the picklist advancedSearch view model from the
// phrase specified.
PicklistAdvancedSearchItem.prototype.load = function picklistAdvancedSearchItemLoad(phrase, not) {
    var selectedValue = null,
        textValue = "",
        operatorValue = "is";

    if (not) {
        if (phrase === "[empty]") {
            operatorValue = "is not empty";
        } else {
            operatorValue = "not";
            selectedValue = this._split(phrase);
        }
    } else if (!stringUtil.isNullOrWhitespace(phrase)) {
        phrase = phrase.trim();
        var withoutWildcards = phrase.replace(shared.removeSurroundingWildcards, "");
        if (phrase === "[empty]") {
            operatorValue = "is empty";
        } else if (withoutWildcards[0] !== phrase[0] && withoutWildcards[textValue.length - 1] !== phrase[phrase.length - 1]) { // test for contains if both leading/trailing characters have changed (* removed)
            operatorValue = "contains";
            textValue = withoutWildcards;
        } else {
            selectedValue = this._split(phrase);
        }
    }

    this.operator(operatorValue);
    this.value.load(textValue);
    this.selected.load(selectedValue);
};


//-------------------------------------------
// Returns the string representation of the search
// phrase based on the currently selected view-model.
PicklistAdvancedSearchItem.prototype.save = function picklistAdvancedSearchItemSave() {
    var phrase, not,
        value = this.value(),
        selected = this.selected(),
        operator = this.operator();

    switch (operator) {
    case "not":
        phrase = this._join(selected);
        not = true;
        break;
    case "contains":
        if (!stringUtil.isNullOrWhitespace(value)) {
            phrase = "*".concat(value.replace(shared.removeSurroundingWildcards, ""), "*");
        } else {
            phrase = "";
        }
        not = false;
        break;
    case "is":
        phrase = this._join(selected);
        not = false;
        break;
    case "is empty":
        phrase = "[empty]";
        not = false;
        break;
    case "is not empty":
        phrase = "[empty]";
        not = true;
        break;
    default:
        phrase = "";
        not = false;
        break;
    }

    return [phrase, not];
};


//-------------------------------------------
// Joins the array of selected pick-list items
// also encodes any `;` (semi-colons).
PicklistAdvancedSearchItem.prototype._join = function picklistAdvancedSearchItemJoin(selected) {
    if (Array.isArray(selected)) {
        var i, l, items = selected.slice();
        for (i = 0, l = items.length; i < l; i += 1) {
            items[i] = items[i].replace(";", "\\;");
        }
        return items.join(";");
    }
    return null;
};


//-------------------------------------------
// Splits the string representation of pick-list
// items and decodes any `\;`.
PicklistAdvancedSearchItem.prototype._split = function picklistAdvancedSearchItemSplit(phrase) {
    if (!stringUtil.isNullOrWhitespace(phrase)) {
        var i, l, selected = phrase.match(splitPicklistRegex);
        for (i = 0, l = selected.length; i < l; i += 1) {
            selected[i] = "".concat(selected[i]).replace("\\;", ";");
        }
        return selected;
    }
    return null;
};

module.exports = PicklistAdvancedSearchItem;




//////////////////
// WEBPACK FOOTER
// ./~/pli/advancedsearch/picklistAdvancedSearchItem.js
// module id = 23
// module chunks = 49